import React from 'react';
import type { SocialNetwork } from '../types/content';
type SocialIconProps = {
  network: SocialNetwork;
  className?: string;
};

/** Hairline social icons drawn to match the lucide stroke style. */
export function SocialIcon({
  network,
  className = 'h-[18px] w-[18px]'
}: SocialIconProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-440" data-mp="3jijrbopcq2ov">
      {network === 'instagram' && <>
          <rect x="3.5" y="3.5" width="17" height="17" rx="5" data-id="element-441" data-mp="34tnllyarp1rf" />
          <circle cx="12" cy="12" r="4" data-id="element-442" data-mp="34v8gxq4wooqc" />
          <circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" data-id="element-443" data-mp="30sk8hjk3tjtw" />
        </>}
      {network === 'facebook' && <path d="M14.5 8.5h2V5h-2.5a3.5 3.5 0 0 0-3.5 3.5V11H8v3.5h2.5V21H14v-6.5h2.4l.6-3.5h-3V9a.5.5 0 0 1 .5-.5Z" data-id="element-444" data-mp="k2n3rnog0c8o" />}
      {network === 'tiktok' && <path d="M14 3.5v11a3.5 3.5 0 1 1-3.5-3.5M14 3.5c.4 2.6 2.2 4.4 5 4.7" data-id="element-445" data-mp="g4flupi8t4vw" />}
    </svg>;
}